import axios, { isAxiosError } from 'axios';
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { store } from '../store';
import { clearTokens } from '../store/slices/authSlice';
import { persistor } from '../store';
import { createStandardError, extractApiError } from '../helpers/errorHandler';
import { getApiBaseUrl } from '../helpers/domainUtils';
import { notification } from 'antd';

export const instance = axios.create({
  baseURL: getApiBaseUrl(),
  paramsSerializer: {
    indexes: null,
  },
});

async function handleRequest(config: InternalAxiosRequestConfig) {
  console.log('---> API REQUEST', config.url, {
    params: config.params,
    data: config.data,
  });

  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }

  const accessToken = store.getState().auth.accessToken;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
}

function handleResolvedRequest(response: AxiosResponse) {
  console.log('<--- API SUCCESS', response.config.url, response.status);
  return response;
}

async function handleRejectedRequest(error: any) {
  if (!isAxiosError(error)) {
    throw error;
  }

  console.log('---> API ERROR', error?.response?.data || error.message);

  if (error.response?.status === 401) {
    store.dispatch(clearTokens());

    try {
      await persistor.purge();
    } catch (purgeError) {
      console.error('Error purging persistor:', purgeError);
    }

    const currentPath = window.location.pathname;
    if (currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/verify-account') {
      window.location.replace('/login');
    }
  }

  try {
    const apiError = extractApiError(error);
    notification.error({
      message: apiError.title || 'Hata',
      description: apiError.message,
      placement: 'topRight',
      duration: 5,
    });
  } catch (notifyErr) {
    console.error('Notification error:', notifyErr);
  }

  const standardError = createStandardError(error);
  throw standardError;
}

instance.interceptors.request.use(handleRequest);

instance.interceptors.response.use(handleResolvedRequest, handleRejectedRequest);
